import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableLayout } from '../../containers/Layout';
import {
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Box,
  TableFooter,
  Typography,
} from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import Currency from '../../../../../commonModules/Currency';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { isEmpty } from 'lodash-es';
import SingleBL from '../../reapproIntern/SingleBL';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import jsPDFInvoiceTemplate,{ OutputType } from "jspdf-invoice-template-nodejs";
import { toast } from 'react-toastify';
import { useCurrency } from '../../../../../../../../jsx/hooks/useCurrency';


const SingleTransferSale = (props) => {
    const currency = useCurrency();

    const dispatch = useDispatch();
	const PRODUCTS = useSelector((state) => state.inventory.products); 

    const [trsf, setTrsf] = useState({});
    const [BL, setBL] = useState(false);
    const [TVA, setTVA] = useState(true);

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(props.transfer.id));
                setTrsf(data);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
    }, [dispatch, props.transfer.id]);

    const createProductList = () => {
        console.log('====================================');
        console.log({trsf});
        console.log('====================================');
        return !isEmpty(trsf) && trsf.products.map((saleItem) => {
            let prod = PRODUCTS && PRODUCTS[saleItem.product_id];
            // let totalTTC = parseFloat(saleItem.total_ttc); // prix vendu TTC
            // let tvaRate = saleItem.tva_rate || saleItem.prod_tva_rate || prod.tva_rate || 0;
            // let totalHT = saleItem.total_ht || totalTTC / (1 + tvaRate / 100); // prix vendu HT
            // Use values directly from backend (now correctly calculated)
            let totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;  // Use saved tva_rate (0 if exempt)
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            // If tvaRate is 0 (VAT exempt), totalTTC should equal totalHT (correct)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }
            
            let PUHT = totalHT / saleItem.quantity;

            return (
                <TableRow key={saleItem.id}>
                    <TableCell className="photo-trsf-single">
                        {prod && prod.photos &&
                            <img 
                                id={prod && prod.photos[0].filename} 
                                src={`/stocks/photos/${prod && prod.photos[0].filename}`} 
                                // style={{width:"100px", height:"auto"}}
                            />
                        }
                    </TableCell>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${saleItem.product_id}`}</TableCell>
                    <TableCell className="text-right">{saleItem.quantity}</TableCell>
                    <TableCell className="text-right"><Currency value={PUHT} /></TableCell>
                    <TableCell className="text-right"><Currency value={totalHT} /></TableCell>
                    {TVA &&
                        <>
                            <TableCell className="text-right">{tvaRate} %</TableCell>
                            <TableCell className="text-right"><Currency value={totalTTC} /></TableCell>
                        </>
                    }
                </TableRow>
            );
        });
    };

    const getTotal = () => {
        let total = 0;
        let totalBase = 0;
        !isEmpty(trsf) && trsf.products.map((saleItem) => {
            let prod = PRODUCTS && PRODUCTS[saleItem.product_id];
            // Use values directly from backend (now correctly calculated)
            let totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;  // Use saved tva_rate (0 if exempt)
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            // If tvaRate is 0 (VAT exempt), totalTTC should equal totalHT (correct)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }

            total += totalTTC;
            totalBase += totalHT;
        });

        return [
            <Currency value={total} />,
            <Currency value={totalBase} />,
        ];
    };

    const createTableOfProduct  = ()=>{
        const tablelist = trsf.products.map((saleItem, index) => {
            let prod = PRODUCTS && PRODUCTS[saleItem.product_id];
            
            // Use values directly from backend (now correctly calculated)
            let totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;  // Use saved tva_rate (0 if exempt)
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            // If tvaRate is 0 (VAT exempt), totalTTC should equal totalHT (correct)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }
            
            let PUHT = totalHT / saleItem.quantity;
            
            console.log("createTableOfProduct-prod",prod)
            console.log("createTableOfProduct-saleItem",saleItem)

            // Conditionally include TVA and TTC columns based on TVA state
            if (TVA) {
                return [
                  index + 1,
                  prod?.ref || `REF-${saleItem.product_id.substring(0, 8)}`,
                  prod?.name || `Product ID: ${saleItem.product_id}`,
                  parseFloat(PUHT.toFixed(2)),
                  saleItem.quantity,
                  parseFloat(totalHT.toFixed(2)),
                  `${tvaRate} %`,
                  parseFloat(totalTTC.toFixed(2)),
                ]
            } else {
                // Exclude TVA and TTC columns
                return [
                  index + 1,
                  prod?.ref || `REF-${saleItem.product_id.substring(0, 8)}`,
                  prod?.name || `Product ID: ${saleItem.product_id}`,
                  parseFloat(PUHT.toFixed(2)),
                  saleItem.quantity,
                  parseFloat(totalHT.toFixed(2)),
                ]
            }
        })
        console.log("createTableOfProduct",tablelist)
        return tablelist
    }
    const calculateTotals = () => {
        let totalHT = 0;
        let totalTVA = 0;
        let totalTTC = 0;
        
        trsf.products.forEach((saleItem) => {
            let prod = PRODUCTS && PRODUCTS[saleItem.product_id];
            // Use values directly from backend (now correctly calculated)
            let itemHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let itemTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;  // Use saved tva_rate (0 if exempt)
            
            // Only recalculate if tvaRate > 0 AND itemTTC equals itemHT (incorrect data)
            // If tvaRate is 0 (VAT exempt), itemTTC should equal itemHT (correct)
            if (tvaRate !== 0 && itemTTC === itemHT) {
                itemTTC = itemHT * (1 + tvaRate / 100);
            }
            
            let itemTVA = itemTTC - itemHT; // TVA amount
            
            totalHT += itemHT;
            totalTVA += itemTVA;
            totalTTC += itemTTC;
        });
        
        return { totalHT, totalTVA, totalTTC };
    };
    
    const wrapText = (text, maxLineLength = 45) => {
        if (!text || text.length <= maxLineLength) {
            return text;
        }
        
        // Split text into multiple lines if it's too long
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';
        
        words.forEach((word) => {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            
            if (testLine.length > maxLineLength) {
                if (currentLine) {
                    lines.push(currentLine);
                    currentLine = word;
                } else {
                    // Single word is too long, split it
                    lines.push(word);
                    currentLine = '';
                }
            } else {
                currentLine = testLine;
            }
        });
        
        if (currentLine) {
            lines.push(currentLine);
        }
        
        return lines.join('\n');
    };

    const getLogoAsBase64 = () => {
        return new Promise((resolve, reject) => {
            // Validate that shop logo exists and has a filename
            if (!props.shop?.logo?.filename) {
                console.warn('[WARN] Shop logo not configured');
                reject(new Error('Shop logo filename is missing'));
                return;
            }
            
            const logoFilename = props.shop.logo.filename;
            const logoPath = `/stocks/photos/${logoFilename}`;
            const fullLogoUrl = window.location.origin + logoPath;
            
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // Handle CORS if needed
            
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas');
                    const aspectRatio = img.naturalWidth / img.naturalHeight;
                    const targetWidth = 40;
                    const targetHeight = targetWidth / aspectRatio;
                    
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                    
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    
                    // Convert to base64 - use PNG to preserve transparency
                    let base64Image;
                    try {
                        base64Image = canvas.toDataURL('image/png');
                    } catch (e) {
                        console.warn('[WARN] PNG conversion failed, using JPEG');
                        base64Image = canvas.toDataURL('image/jpeg', 0.95);
                    }
                    
                    resolve({ 
                        src: base64Image,
                        width: targetWidth, 
                        height: targetHeight,
                        type: base64Image.startsWith('data:image/png') ? 'PNG' : 'JPEG'
                    });
                } catch (err) {
                    console.error('[ERROR] Failed to convert logo to base64:', err);
                    reject(err);
                }
            };
            
            img.onerror = (error) => {
                console.error('[ERROR] Logo failed to load:', logoPath);
                console.error('[ERROR] Try opening URL:', fullLogoUrl);
                reject(new Error(`Failed to load logo from: ${logoPath}`));
            };
            
            img.src = logoPath;
        });
    };

    const downloadInvoicePDF = async () =>{
        const totals = calculateTotals();
        
        let logoData;
        try {
            logoData = await getLogoAsBase64();
        } catch (err) {
            console.warn('[WARN] Logo not available, PDF will be generated without logo');
            logoData = null;
        }

        const invoiceData = {
            invoiceNumber: trsf.intern_ref_id,
        }
        
        // Validate invoice number
        if (!trsf.intern_ref_id) {
            console.error('[ERROR] Invoice number is missing!');
            toast.error('⚠️ Numéro de facture manquant!');
        }
        
        // Build header conditionally based on TVA state
        const headerColumns = [
          {
            title: "#", 
            style: { 
              width: 10 
            } 
          }, 
          { 
            title: "Code",
            style: {
              width: TVA ? 25 : 35
            } 
          }, 
          { 
            title: "Nom",
            style: {
              width: TVA ? 55 : 80
            } 
          }, 
          { 
            title: "Prix HT",
            style: {
              width: TVA ? 20 : 23
            }
          },
          { 
            title: "Quantité",
            style: {
              width: TVA ? 18 : 20
            }
          },
          { 
            title: "Total HT",
            style: {
              width: TVA ? 25 : 25
            }
          }
        ];
        
        // Add TVA and TTC columns only if TVA is enabled
        if (TVA) {
          headerColumns.push(
            { 
              title: "TVA",
              style: {
                width: 15
              }
            },
            { 
              title: "Total TTC",
              style: {
                width: 25
              }
            }
          );
        }
        
        // Build additional rows conditionally based on TVA state
        const additionalRows = TVA ? [
          {
              col1: 'Total:',
              col2: String(totals.totalTTC.toFixed(2)),
              col3: currency || 'FCFA',
              style: {
                  fontSize: 14 //optional, default 12
              }
          },
          {
              col1: 'TVA:',
              col2: String(totals.totalTVA.toFixed(2)),
              col3: currency || 'FCFA',
              style: {
                  fontSize: 10 //optional, default 12
              }
          },
          {
              col1: 'Sous-total HT:',
              col2: String(totals.totalHT.toFixed(2)),
              col3: currency || 'FCFA',
              style: {
                  fontSize: 10 //optional, default 12
              }
          }
        ] : [
          {
              col1: 'Total HT:',
              col2: String(totals.totalHT.toFixed(2)),
              col3: currency || 'FCFA',
              style: {
                  fontSize: 14 //optional, default 12
              }
          }
        ];
        
        var invoice = {
            outputType: OutputType.Save,
            retsurnJsPDFDocObject: true,
            fileName: `facture-${invoiceData.invoiceNumber || trsf.id || 'unknown'}.pdf`,
            orientationLandscape: false,
            compress: true,
        };
        
        // Only add logo if it was successfully loaded and converted
        if (logoData) {
            invoice.logo = {
                src: logoData.src,
                type: logoData.type,
                width: logoData.width,
                height: logoData.height,
                margin: {
                    top: 0,
                    left: 0
                }
            };
        }
        
        // Continue building invoice object
        invoice.stamp = {
            inAllPages: true, //by default = false, just in the last page
            src: "https://raw.githubusercontent.com/edisonneza/jspdf-invoice-template/demo/images/qr_code.jpg",
            type: 'JPEG', // This is a JPEG from external URL (no transparency expected)
            width: 20, //aspect ratio = width/height
            height: 20,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        };
        
        invoice.business = {
            name: props.shop.name+"",
            address: props.shop.address+" "+props.shop.city+" - "+props.shop.country,
            phone: props.shop.tel+"",
            email: props.shop.email+"",
            //email_1: props.shop.email_1+"",
            //website: props.shop.website+"",
        };
        
        // Build client name - check for potential overflow and wrap text
        const clientFullNameOriginal = props.client.client_firstname+" "+props.client.client_lastname.toUpperCase();
        const invoiceNumber = trsf.intern_ref_id || trsf.id || 'N/A';
        
        // Define maximum line length for wrapping
        const MAX_CLIENT_NAME_LINE_LENGTH = 45;
        
        let clientFullName = clientFullNameOriginal;
        let wasWrapped = false;
        
        // Check if wrapping is needed (text too long for one line)
        if (clientFullNameOriginal.length > MAX_CLIENT_NAME_LINE_LENGTH) {
            clientFullName = clientFullNameOriginal//wrapText(clientFullNameOriginal, MAX_CLIENT_NAME_LINE_LENGTH);
            wasWrapped = true;
            toast.info('ℹ️ Nom du client affiché sur plusieurs lignes');
        }
        
        if (invoiceNumber.length > 30) {
            console.warn('[WARN] Invoice number is very long:', invoiceNumber);
        }
        
        invoice.contact = {
            label: trsf.nature === "vente" ? "Facture pour :":"Devis pour :",
            name: clientFullName, // Will contain \n for line breaks if wrapped
            address: props.client.client_address+"",
            phone: props.client.client_tel+"",
            //email: "client@website.al",
            otherInfo: props.client.client_city+" - "+props.client.client_country,
        };
        
        invoice.invoice = {
            label: trsf.nature === "vente" ?"Facture n° ":"Devis n° ",
            num: invoiceNumber, // Use the validated invoice number
            invDate: trsf.nature === "vente" ?"Date Paiement: "+(new Date(trsf.creation_date)).toLocaleString('fr-FR'):"Date Cotation: "+(new Date(trsf.creation_date)).toLocaleString('fr-FR'),
            invGenDate: trsf.nature === "vente" ?"Date Facture: "+(new Date(trsf.creation_date)).toLocaleString('fr-FR'):"Date Mise à jour stock: "+(new Date()).toLocaleString('fr-FR'),
            headerBorder: true,
            tableBodyBorder: true,
            header: headerColumns,
            table: createTableOfProduct(),
            additionalRows: additionalRows,
            invDescLabel: "Note",
            invDesc: trsf.comments,
            styles: {
                cellPadding: 5,
                minCellHeight: 18,
                lineColor: [0, 0, 0],
                lineWidth: 0.3
            },
            headerStyles: {
                fillColor: [240, 240, 240],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                minCellHeight: 20,
                cellPadding: 5
            },
            bodyStyles: {
                minCellHeight: 18,
                cellPadding: 5
            }
        };
        
        invoice.footer = {
            text: props.shop.bottom_info+"\n"+props.shop.bottom_info2+"\n"+props.shop.bottom_info3,
        };
        
        invoice.pageEnable = true;
        invoice.pageLabel = "Page ";
        
        try{
            const pdfObject = jsPDFInvoiceTemplate(invoice);
            
            if (logoData) {
                toast.success('PDF téléchargé avec succès!');
            } else {
                toast.success('PDF téléchargé avec succès! (sans logo)');
            }
        }catch(err){
            console.error('[ERROR] PDF generation failed:', err.message);
            toast.error(`[ERROR] Downloading PDF: ${err.message}`);
            
            if (!logoData) {
                toast.error("[ERROR] Vérifier le logo du magasin");
            }
        }

    }
    return (
        <SingleTransferTemplate
            shop={props.shop}
            client={props.client}
            shopDest={props.shopDest}
            sale={trsf}
            transfer={trsf}
            agent={props.agent}
            notif={props.notif}
            handleBL={() => setBL(!BL)}
            downloadInvoicePDF={downloadInvoicePDF}
            BL={BL}
            BLOpt
            TVA={TVA}
            TVAOpt
            handleCheck={() => setTVA(!TVA)}
        >
        {BL ?
            <SingleBL
                PRODUCTS={PRODUCTS}
                transfer={trsf}
            />
        :
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell className="text-left">Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                        <TableCell>PU HT</TableCell>
                        <TableCell>Total HT</TableCell>
                        {TVA &&
                            <>
                                <TableCell>TVA</TableCell>
                                <TableCell>Total TTC</TableCell>
                            </>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {createProductList()}
                    <TableRow>
                        <TableCell colSpan={9}></TableCell>
                    </TableRow>
                </TableBody>

                <TableFooter>
                    <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell style={{ textAlign: "right" }}>
                        <Typography variant="h6">Total</Typography>
                    </TableCell>
                    <TableCell className="f-700">
                        <Typography variant="h6"><b>{getTotal()[1]}</b></Typography>
                    </TableCell>
                    {TVA &&
                        <>
                        <TableCell></TableCell>
                        <TableCell>
                            <Typography variant="h6"><b>{getTotal()[0]}</b></Typography>
                        </TableCell>
                        </>
                    }
                    </TableRow>
                </TableFooter>
            </TableLayout>
        }
        </SingleTransferTemplate>
    );
};

export default SingleTransferSale;
